"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ThemeContext: function() {
        return _index.ThemeContext;
    },
    ThemeProvider: function() {
        return _index.ThemeProvider;
    }
});
const _index = require("./ThemeContext/index");
